/**
 * The engagement's own file reference — 'ENG-<id>'.
 *
 * An engagement carries no editable code: the reference is its primary key
 * rendered for people, the same shape every workflow request number has
 * ('<prefix>-<id>', filled from the row's own SERIAL). So it is unique, cannot
 * be typed or changed by anyone, and stays with the engagement for life.
 *
 * The prefix lives here and nowhere else, for both halves of the app —
 * CommonJS so the API can require() it and the React build can import it.
 * Surfaces that show it: the Independence Confirmation's "File ref." box (PDF
 * and mail), the engagement list and detail, the attachment list, and the
 * engagement coverage lists on the workflow pages.
 *
 * ENG- is free: Engagement Registration issues ENR-, and no other flow uses it.
 */

const ENGAGEMENT_NO_PREFIX = 'ENG-';

/**
 * @param {number|string|null} id  engagements.id
 * @returns {string} 'ENG-305', or '' when there is no id to render
 */
const engagementNo = (id) => (id == null || id === '' ? '' : `${ENGAGEMENT_NO_PREFIX}${id}`);

/**
 * The same value as a SQL expression, so a query can select or search on it
 * without the prefix being written a second time.
 * @param {string} alias  the engagements table alias in the query (e.g. 'e')
 */
const engagementNoSql = (alias) => `('${ENGAGEMENT_NO_PREFIX}' || ${alias}.id)`;

module.exports = { ENGAGEMENT_NO_PREFIX, engagementNo, engagementNoSql };
